import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";
require("prismjs/themes/prism-okaidia.css");
import parse from "html-react-parser";
import Picture from "gatsby-image";
import Seo from "../components/Seo";
import Article from "../components/Article";
import Post from "../components/Post";
import { ThemeContext } from "../layouts";

const PostTemplate = props => {
  const {
    data: {
      post,
      googleDocImages,
      authornote: { html: authorNote }
    },
    pageContext: { next, prev }
  } = props;

  const options = {
    replace: domNode => {
      const { children } = domNode
      if (!children) return
      const hasImgTag = children.find(img => img.name === "img")
      if (hasImgTag) {
        const { attribs } = hasImgTag
        const { src, alt } = attribs
        return (
          <Picture
            fluid={
              googleDocImages.edges.find(
                ({ node }) => node.id === src
              ).node.childImageSharp.fluid
            }
            alt={alt}
            className="ui fluid image"
          />
        )
      }
    },
  };

  if (googleDocImages && googleDocImages.edges && googleDocImages.edges.find) {
    post.htmlReact = parse(post.html, options);
  } else {
    post.htmlReact = parse(post.html);
  }

  return (
    <React.Fragment>
      <ThemeContext.Consumer>
        {theme => (
          <Article theme={theme}>
            <Post
              post={post}
              next={next}
              prev={prev}
              authornote={authorNote}
              theme={theme}
            />
          </Article>
        )}
      </ThemeContext.Consumer>

      <Seo data={post} />
    </React.Fragment>
  );
};

PostTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired
};

export default PostTemplate;

//eslint-disable-next-line no-undef
export const postQuery = graphql`
  query PostBySlug($slug: String!) {
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      fields {
        slug
        prefix
      }
      excerpt
      frontmatter {
        title
        author
        tags
        cover {
          childImageSharp {
            resize(width: 300) {
              src
            }
          }
        }
      }
      parent {
        ...on File {
          modifiedTime(formatString: "YYYY-MM-DD")
        }
      }
    }
    googleDocImages: allFile(filter: {name: {glob: "google-doc-image-**"}}) {
      edges {
        node {
          id
          name
          childImageSharp {
            fluid {
              base64
              tracedSVG
              aspectRatio
              src
              srcSet
              srcWebp
              srcSetWebp
              sizes
              originalImg
              originalName
              presentationWidth
              presentationHeight
            }
          }
        }
      }
    }
    authornote: markdownRemark(fileAbsolutePath: { regex: "/author/" }) {
      id
      html
    }
  }
`;
